import React from "react";

const FortellisTitle2 = ({ title }) => {
  return <div className="fortellis-title-2">{title}</div>;
};

export default FortellisTitle2;
